export default __webpack_public_path__ + "static/media/studentRealCase1-mobile-en.0d70a78c.png";